<template>
  <div>
    <div class="banner">
      <img width="100%" src="../../../assets/latest_news_banner.webp" alt="" />
    </div>

    <div class="main">
      <div class="content">
        <h2 style="color: #9c0; font-size: 30px; line-height: 36px">
          <b>{{ $t(`${title}`) }}</b>
        </h2>
        <div class="news_list" v-for="(item,index) in link" :key="index">
          <a
            :href="item.path"
            target="_blank"
            >{{ $t(`${item.title}`) }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    link: {
      type: Array,
      default: []
    },
    subTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.main {
  margin-top: 30px;
  display: flex;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;

  b {
    margin-bottom: 10%;
    font-weight: 700;
    color: rgb(153, 204, 0);
    font-size: 30px;
    line-height: 36px;
  }

  .content {
    width: 80%;
    margin-left: 5%;
    text-align: left;
  }

  a {
    cursor: pointer;
    font-size: 14px;
    color: #256daf;
  }

  a:visited {
    text-decoration: none;
    color: #256daf;
  }

  a:hover {
    color: #165896;
  }
  .news_list {
    margin: 20px 0;
  }
}
</style>
